import { Component, ElementRef, ErrorHandler, OnInit, ViewChild, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import { WindowRef } from '../../shared/windowRef.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-against-notification-form',
  templateUrl: './against-notification-form.component.html',
  styleUrls: ['./against-notification-form.component.css']
})
export class AgainstNotificationFormComponent implements OnInit {
@ViewChild('Image') imageInput: ElementRef;
 existingFiles = {
  APP_PA_Photo: '',
  APP_PA_Signature: '',
  APP_SA_Photo:'',
  APP_SA_Signature:''

 }
fileToUpload: File | null = null;
applicantPhotoPreview: string | ArrayBuffer | null = null;
showPreview: boolean = false;
signaturePhotoPreview: string | ArrayBuffer | null = null;
showsignaturePreview: boolean = false;
showcoapplicantPreview: boolean = false;
coapplicantPhotoPreview: string | ArrayBuffer | null = null;
showcoapplicantsignaturePreview: boolean = false;
coapplicantsignaturePreview: string | ArrayBuffer | null = null;
  r: any = {};
  re: any;
  data: any;
  pdId: any;
  role: any;
  id: any;
  app: any = {};
  responseData: any;
  PD: any;
  NotificationPropertyType: string;
  // fileToUpload: File = null;
  APP_PA_Age: any;
  NO_Date: any;
   APP_SA_Age: any;
     Relations: any;
       formInvalid: boolean;
         Categories: any;
  NotificationId: any;
  isDocumentsLoaded: boolean;
  paymentStatusIDamount: any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.app.APP_IsJoint = 'N';
  }

  ngOnInit() {
    //this.r = {};
   // this.responseData = '';
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
      this.pdId = params['pdId'];
      this.role = params['role'];
    });
    this.route.queryParams.subscribe(params => {
      if (params['data']) {
           // ← Guard: only allow if arrived via legitimate verify submit
    if (!sessionStorage.getItem('regVerified')) {
      this.router.navigate(['/applicant-register']);
      return;
    }
    sessionStorage.removeItem('regVerified'); // ← consume the flag
        

        this.responseData = params['data'];
        console.log('Received response data: ', this.responseData);
         this.GetByIdVerify(this.responseData);
        // Use responseData as needed in your component
      }
    });
    //this.GetByIdVerify(this.responseData);
    this.GetProjectDetailsforapplication();
     this.GetRelations();
      this.getCategoryforform(this.NotificationId);
  }
  // GetByIdVerify(mobileNo: any) {
  //   //debugger;
  //   document.getElementById('loader-spinner').style.display = "block";
  //   this.data = this.userService.GetByIdverification(mobileNo, this.id, this.pdId);
  //   this.data.subscribe(
  //     (response: any) => {
  //       this.r = response;
  //       // }
  //       this.CalculateAge(this.app.Date_Of_Birth, this.NO_Date);
  //         this.CalculateCoapplicantAge(this.app.APP_SA_DOB, this.NO_Date);
  //       document.getElementById('loader-spinner').style.display = "none";
  //     },
  //     (error) => {
  //       console.error(error);
  //       document.getElementById('loader-spinner').style.display = "none";
  //     }
  //   );
  // }


//   GetByIdVerify(mobileNo: any) {
//     debugger;

//   document.getElementById('loader-spinner').style.display = "block";

//   this.userService.GetByIdverification(mobileNo, this.id, this.pdId)
//     .subscribe(
//       (response: any) => {
//         console.log(response);
//         console.log("Full API Response:", response);

//         // ✅ assign actual data
//         this.r = response.data;
//               this.app = {};
//         console.log(this.r);

// // if (this.r.APP_PA_DOB) {
// //   this.app.APP_PA_DOB = new Date(this.r.APP_PA_DOB).toISOString().split('T')[0];
// //   console.log(this.app.APP_PA_DOB); // Should log "2000-01-01"
// // }
// if (this.r.APP_PA_DOB) {
//   // ✅ Just take the date part directly from the string
//   this.app.APP_PA_DOB = this.r.APP_PA_DOB.split('T')[0];
//   console.log(this.app.APP_PA_DOB); // "1999-01-01" ✅
// }
// console.log('date of birth:',this.app.APP_PA_DOB);
//  this.app.APP_PA_PanNo = this.r.APP_PA_PanNo;
//  this.app.APP_Landline_No = this.r.APP_Landline_No;
//  this.app.APP_CA_Id_FK = this.r.APP_CA_Id_FK;
//  this.app.APP_IsJoint = this.r.APP_IsJoint;
//  this.app.APP_PA_Photo = this.r.APP_PA_Photo;
//  this.app.APP_PA_Signature = this.r.APP_PA_Signature;
// console.log('data:',this.app.APP_PA_Photo);


//  if(this.app.APP_IsJoint = 'Y')
//  {
//   this.app.APP_SA_Name = this.r.APP_SA_Name;

// this.r.APP_SA_DOB.split('T')[0];

//   if (this.r.APP_SA_DOB) {
//   this.app.APP_SA_DOB = this.r.APP_SA_DOB.split('T')[0];
//   console.log(this.app.APP_SA_DOB); // Should log "2000-01-01"
// }
//   this.app.APP_IsJoint = this.r.APP_IsJoint;
//   //this.app.APP_SA_DOB = this.r.APP_SA_DOB;
//   this.app.APP_SA_Age = this.r.APP_SA_Age;
//   this.app.APP_SA_PanNo = this.r.APP_SA_PanNo;
//   this.app.APP_SA_Relation_Id_FK = this.r.APP_SA_Relation_Id_FK;
//   this.app.APP_SA_Photo = this.r.APP_SA_Photo;
//   this.app.APP_SA_Signature = this.r.APP_SA_Signature;


//  }

//         // If you want to bind editable fields
//         //  this.app.APP_PA_DOB = this.r.APP_PA_DOB;
//         //  console.log(this.app.APP_PA_DOB);
//          this.getCategoryforform(this.NotificationId, this.app.APP_CA_Id_FK);
//          this.APP_PA_Age = this.r.APP_PA_Age;
//          this.APP_SA_Age = this.r.APP_SA_Age;
//         console.log(this.app.APP_PA_Age);
         
//         // Calculate age
//         //this.CalculateAge(this.r.Date_Of_Birth, this.PD.NO_Date);
//         //this.CalculateCoapplicantAge(this.r.APP_SA_DOB, this.PD.NO_Date);

//         document.getElementById('loader-spinner').style.display = "none";
//       },
//       (error) => {
//         console.error(error);
//         document.getElementById('loader-spinner').style.display = "none";
//       }
//     );
// }



GetByIdVerify(mobileNo: any) {
  debugger;
  document.getElementById('loader-spinner').style.display = "block";

  this.userService.GetByIdverification(mobileNo, this.id, this.pdId)
    .subscribe(
      (response: any) => {
        console.log(response);
        this.r = response.data;
        this.app = {};

        if (this.r.APP_PA_DOB) {
          this.app.APP_PA_DOB = this.r.APP_PA_DOB.split('T')[0];
          console.log(this.app.APP_PA_DOB);
        }

        this.app.APP_PA_PanNo = this.r.APP_PA_PanNo;
        this.app.APP_Landline_No = this.r.APP_Landline_No;
        this.app.APP_CA_Id_FK = this.r.APP_CA_Id_FK;
        this.app.APP_PA_Photo = this.r.APP_PA_Photo;
        this.app.APP_PA_Signature = this.r.APP_PA_Signature;
         this.app.APP_SA_Photo = this.r.APP_SA_Photo;
        this.app.APP_SA_Signature = this.r.APP_SA_Signature;
        
        this.paymentStatusIDamount = this.r.status;

         this.existingFiles.APP_PA_Photo  = this.r.APP_PA_Photo;
          this.existingFiles.APP_PA_Signature   = this.r.APP_PA_Signature;
           this.existingFiles.APP_SA_Photo  = this.r.APP_SA_Photo;
          this.existingFiles.APP_SA_Signature   = this.r.APP_SA_Signature;
//         if (this.checkValid(this.r.APP_PA_Photo)) {
//   this.existingFiles.APP_PA_Photo = this.r.APP_PA_Photo;
// }

// if (this.checkValid(this.r.APP_PA_Signature)) {
//   this.existingFiles.APP_PA_Signature = this.r.APP_PA_Signature;
// }
        
        
        // if(this.app.APP_PA_Photo = )
        // this.formInvalid = true;

        // ✅ Fix: use === for comparison, default to 'N' if null
        this.app.APP_IsJoint = this.r.APP_IsJoint ? this.r.APP_IsJoint : 'N';

        if (this.app.APP_IsJoint === 'Y') {  // ✅ === instead of =
          this.app.APP_SA_Name = this.r.APP_SA_Name;

          if (this.r.APP_SA_DOB) {
            this.app.APP_SA_DOB = this.r.APP_SA_DOB.split('T')[0];
            console.log(this.app.APP_SA_DOB);
          }

          this.app.APP_SA_Age = this.r.APP_SA_Age;
          this.app.APP_SA_PanNo = this.r.APP_SA_PanNo;
          this.app.APP_SA_Relation_Id_FK = this.r.APP_SA_Relation_Id_FK;
          this.app.APP_SA_Photo = this.r.APP_SA_Photo;
          this.app.APP_SA_Signature = this.r.APP_SA_Signature;
        }

        this.getCategoryforform(this.NotificationId, this.app.APP_CA_Id_FK);
        this.APP_PA_Age = this.r.APP_PA_Age;
        this.APP_SA_Age = this.r.APP_SA_Age;
        this.checkAllRequiredDocuments();
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
}
  GetProjectDetailsforapplication() {

    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getProjectDetailsforApplication(this.id, this.pdId);
    this.data.subscribe(
      (response: any) => {
        this.PD = response;
        this.NotificationId = this.PD.NO_Id;
        if (this.PD.DSWOId_NORF_Sites != 0) {
          this.NotificationPropertyType = 'Plot';
        }
        else if (this.PD.DSWOId_NORF_Houses != 0) {
          this.NotificationPropertyType = 'House';
        }
        else if (this.PD.DSWOld_NORF_Flat != 0) {
          this.NotificationPropertyType = 'Flat';
        }
 if (this.NotificationId) {
            this.getCategoryforform(this.NotificationId);
          }

        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  // ApplicantPhotographcertificateFileInput(file: FileList) {


  //   let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;



  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_PA_PhotoErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_PA_Photo');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_PA_Photo');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

  // getApplicantPhotographcertificateFileInput() {
  //   let imagename = null;
  //   try {
  //     imagename = document.getElementById('APP_PA_Photo');
  //     return imagename.files[0].name;
  //   }
  //   catch (e) {
  //     return null;
  //   }
  // }



  ApplicantPhotographcertificateFileInput(event: any) {

  const file: File = event.target.files[0];

  // if (!file) return;
    if (!file) {
    // User cleared the input — wipe the preview too
    this.applicantPhotoPreview = null;
    this.showPreview = false;
    this.app.APP_PA_Photo = "";
    this.checkAllRequiredDocuments();
    return;
  }

  const regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

  const sizeInKB = file.size / 1024;
  const uploadedFilename = file.name;

  // ✅ Validation
  if (!uploadedFilename.match(regex)) {
    swal('Warning!', "Please upload an image file with extension .jpg", 'warning');
    this.resetFileInput();
    this.app.APP_PA_Photo = "";
    return;
  }

  if (sizeInKB > 2048) {
    swal('Warning!', "Please upload file less than 2MB", 'warning');
    this.resetFileInput();
    this.app.APP_PA_Photo = "";
    return;
  }

  // ✅ Store file
  this.fileToUpload = file;

  // ✅ Preview Image
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.applicantPhotoPreview = e.target.result;
  };
  reader.readAsDataURL(file);

  // ✅ Upload to Server
  const data = new FormData();
  data.append("UploadedImage", file);

  this.userService.uploadImage(data).subscribe(
    (response: any) => {
      console.log(response);
      this.app.APP_PA_PhotoErrorMessage = "";
      this.checkAllRequiredDocuments();
    },
    (error) => {
      this.resetFileInput();
      this.app.APP_PA_Photo = "";
      
      if (error.status === 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    }
  );
}

resetFileInput() {
  if (this.imageInput) {
    this.imageInput.nativeElement.value = '';
  }
  this.applicantPhotoPreview = null;
  this.showPreview = false;
}
// getApplicantPhotographcertificateFileInput() {
//   if (this.fileToUpload) {
//     return this.fileToUpload.name;
//   }
//   return null;
// }
  // SignatureoftheapplicantFileInput(file: FileList) {


  //   let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

  //   let s: any = file.item(0).size / 1024;
  //   let size: any = parseFloat(s).toFixed(2);
  //   let uploadedFilename = file.item(0).name;
  //   if (uploadedFilename.match(regex) && (size <= 2048)) {
  //     this.fileToUpload = file.item(0);
  //     var reader = new FileReader();
  //     reader.onload = (event: any) => {
  //       // this.UO_UploadimageUrl1 = event.target.result;
  //     }
  //     reader.readAsDataURL(this.fileToUpload);
  //     const data = new FormData();
  //     data.append("UploadedImage", file.item(0));
  //     let x = this.userService.uploadImage(data);
  //     x.subscribe(
  //       (response) => {
  //         console.log(response);
  //         this.app.APP_PA_SignatureErrorMessage = "";
  //       }, (error) => {
  //         let i: any = document.getElementById('APP_PA_Signature');
  //         i.value = "";
  //         if (error.status == 400) {
  //           // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //           swal('Warning!', error.error.Message, 'warning');
  //         }
  //       });
  //   }
  //   else {
  //     let i: any = document.getElementById('APP_PA_Signature');
  //     i.value = "";
  //     if (!uploadedFilename.match(regex))
  //       swal('Warning!', "Please upload a image file with extension  .jpg", 'warning');
  //     else if (size > 2048)
  //       swal('Warning!', "Please upload file less than 2mb", 'warning');
  //   }
  // }

  // getSignatureoftheapplicantFileInput() {
  //   let imagename = null;
  //   try {
  //     imagename = document.getElementById('APP_PA_Signature');
  //     return imagename.files[0].name;
  //   }
  //   catch (e) {
  //     return null;
  //   }
  // }


    SignatureoftheapplicantFileInput(event: any) {

  const file: File = event.target.files[0];

  // if (!file) return;
   if (!file) {
    // User cleared the input — wipe the preview too
    this.signaturePhotoPreview = null;
    this.showsignaturePreview = false;
    this.app.APP_PA_Signature = "";
    this.checkAllRequiredDocuments();

    return;
  }

  const regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

  const sizeInKB = file.size / 1024;
  const uploadedFilename = file.name;

  // ✅ Validation
  if (!uploadedFilename.match(regex)) {
    swal('Warning!', "Please upload an image file with extension .jpg", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_PA_Signature = "";
    return;
  }

  if (sizeInKB > 2048) {
    swal('Warning!', "Please upload file less than 2MB", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_PA_Signature = "";
    return;
  }

  // ✅ Store file
  this.fileToUpload = file;

  // ✅ Preview Image
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.signaturePhotoPreview = e.target.result;
  };
  reader.readAsDataURL(file);

  // ✅ Upload to Server
  const data = new FormData();
  data.append("UploadedImage", file);

  this.userService.uploadImage(data).subscribe(
    (response: any) => {
      console.log(response);
      this.app.APP_PA_PhotoErrorMessage = "";
      this.checkAllRequiredDocuments();
    }
    ,
    (error) => {
      this.resetsignatureFileInput();
      this.app.APP_PA_Signature = "";
      if (error.status === 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    }
  );
}

resetsignatureFileInput() {
  if (this.imageInput) {
    this.imageInput.nativeElement.value = '';
  }
  this.signaturePhotoPreview = null;
  this.showsignaturePreview = false;
}
// getSignatureoftheapplicantFileInput() {
//   if (this.fileToUpload) {
//     return this.fileToUpload.name;
//   }
//   return null;
// }

  // CalculateAge(dateOfBirth: string, NO_Date): void {
  //   // Extract the date part from the ISO string

  //   // this.PD.NO_Date = NO_Date;
  //   const formattedDateOfBirth = dateOfBirth.split('T')[0];
  //   const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
  //   this.app.APP_PA_DOB = this.r.APP_PA_DOB 
  //   ? this.r.APP_PA_DOB.split('T')[0] 
  //   : null;
  //   this.data = this.userService.calculateAgeforApplication(formattedDateOfBirth, formattedNotificationDate);
  //   this.data.subscribe(
  //     (response: any) => {
  //       if (response >= 18) {
  //         this.APP_PA_Age = response;
  //       } else {
  //         swal('Warning!', 'Your Age is less than 18 years.', 'warning');
  //         this.r.APP_PA_DOB = null;
  //         this.APP_PA_Age = null;
  //       }
  //       document.getElementById('loader-spinner').style.display = 'none';
  //     },
  //     (error) => {
  //       document.getElementById('loader-spinner').style.display = 'none';
  //       console.error('Error fetching age:', error);
  //     }
  //   );

  // }
  // CalculateCoapplicantAge(dateOfBirth, NO_Date) {
  //     const formattedDateOfBirth = dateOfBirth.split('T')[0];
  //     const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
  //     this.app.APP_SA_DOB = this.r.APP_SA_DOB 
  //   ? this.r.APP_SA_DOB.split('T')[0] 
  //   : null;
  //     this.data = this.userService.calculateAgeforCoApplication(formattedDateOfBirth, formattedNotificationDate);
  //     this.data.subscribe(
  //       (response: any) => {
  //         if (response >= 18)
  //           this.APP_SA_Age = response;
  //         else {
  //           swal('Warning!', "Age cannot be less than 18 years to apply", 'warning');
  //           this.app.APP_SA_DOB = null;
  //           this.APP_SA_Age = null;
  //         }
  //         document.getElementById('loader-spinner').style.display = "none";
  //       }, (error) => {
  //         document.getElementById('loader-spinner').style.display = "none";
  //       });
  //   }


  CalculateAge(dateOfBirth: string): void {
    debugger;
    // Extract the date part from the ISO string

    // this.PD.NO_Date = NO_Date;
    const formattedDateOfBirth = dateOfBirth.split('T')[0];
   // const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
    this.app.APP_PA_DOB = this.r.APP_PA_DOB 
    ? this.r.APP_PA_DOB.split('T')[0] 
    : null;
    this.data = this.userService.calculateAgeforApplication(formattedDateOfBirth);
    this.data.subscribe(
      (response: any) => {
        if (response >= 18) {
          console.log(response.APP_PA_DOB);
          this.APP_PA_Age = response;
          this.app.APP_PA_DOB = dateOfBirth;
        } else {
          swal('Warning!', 'Your Age is less than 18 years.', 'warning');
          this.r.APP_PA_DOB = null;
          this.APP_PA_Age = null;
        }
        document.getElementById('loader-spinner').style.display = 'none';
      },
      (error) => {
        document.getElementById('loader-spinner').style.display = 'none';
        console.error('Error fetching age:', error);
      }
    );

  }
  CalculateCoapplicantAge(dateOfBirth) {
      const formattedDateOfBirth = dateOfBirth.split('T')[0];
     // const formattedNotificationDate = this.PD.NO_Date.split('T')[0];
      this.app.APP_SA_DOB = this.r.APP_SA_DOB 
    ? this.r.APP_SA_DOB.split('T')[0] 
    : null;
      this.data = this.userService.calculateAgeforCoApplication(formattedDateOfBirth);
      this.data.subscribe(
        (response: any) => {
          if (response >= 18){
            console.log(response.App_SA_DOB);
            this.APP_SA_Age = response;
            this.app.APP_SA_DOB = dateOfBirth;
          }
          else {
            swal('Warning!', "Age cannot be less than 18 years to apply", 'warning');
            this.app.APP_SA_DOB = null;
            this.APP_SA_Age = null;
          }
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
        });
    }



  GetRelations() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.getRelationsforapplicant();
    this.data.subscribe(
      (response: any) => {
        this.Relations = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }
  


// CoApplicantPhotographcertificateFileInput(file: FileList) {
// // let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
// //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
//  let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

//     // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
//     let s: any = file.item(0).size / 1024;
//     let size: any = parseFloat(s).toFixed(2);
//     let uploadedFilename = file.item(0).name;
//     if (uploadedFilename.match(regex) && (size <= 2048)) {
//       this.fileToUpload = file.item(0);
//       var reader = new FileReader();
//       reader.onload = (event: any) => {
//         // this.UO_UploadimageUrl1 = event.target.result;
//       }
//       reader.readAsDataURL(this.fileToUpload);
//       const data = new FormData();
//       data.append("UploadedImage", file.item(0));
//       let x = this.userService.uploadImage(data);
//       x.subscribe(
//         (response) => {
//           console.log(response);
//           this.app.APP_SA_PhotoErrorMessage = "";
//         }, (error) => {
//           let i: any = document.getElementById('APP_SA_Photo');
//           i.value = "";
//           if (error.status == 400) {
//             // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
//             swal('Warning!', error.error.Message, 'warning');
//           }
//         });
//     }
//     else {
//       let i: any = document.getElementById('APP_SA_Photo');
//       i.value = "";
//       if (!uploadedFilename.match(regex))
//         swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
//       else if (size > 2048)
//         swal('Warning!', "Please upload file less than 2mb", 'warning');
//     }
//   }

//   getCoApplicantPhotographcertificateFileInput() {
//     let imagename = null;
//     try {
//       imagename = document.getElementById('APP_SA_Photo');
//       return imagename.files[0].name;
//     }
//     catch (e) {
//       return null;
//     }
//   }
  

 CoApplicantPhotographcertificateFileInput(event: any) {

  const file: File = event.target.files[0];

  // if (!file) return;
  if (!file) {
    // User cleared the input — wipe the preview too
    this.coapplicantPhotoPreview = null;
    this.showcoapplicantPreview = false;
    this.app.APP_SA_Photo = "";
    this.checkAllRequiredDocuments();
    return;
  }

  const regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

  const sizeInKB = file.size / 1024;
  const uploadedFilename = file.name;

  // ✅ Validation
  if (!uploadedFilename.match(regex)) {
    swal('Warning!', "Please upload an image file with extension .jpg", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_SA_Photo = "";
    return;
  }

  if (sizeInKB > 2048) {
    swal('Warning!', "Please upload file less than 2MB", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_SA_Photo = "";
    return;
  }

  // ✅ Store file
  this.fileToUpload = file;

  // ✅ Preview Image
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.coapplicantPhotoPreview = e.target.result;
  };
  reader.readAsDataURL(file);

  // ✅ Upload to Server
  const data = new FormData();
  data.append("UploadedImage", file);

  this.userService.uploadImage(data).subscribe(
    (response: any) => {
      console.log(response);
      this.app.APP_PA_PhotoErrorMessage = "";
    },
    (error) => {
      this.resetcoapplicantFileInput();
      this.app.APP_SA_Photo = "";
      if (error.status === 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    }
  );
}

resetcoapplicantFileInput() {
  if (this.imageInput) {
    this.imageInput.nativeElement.value = '';
  }
  this.coapplicantPhotoPreview = null;
  this.showcoapplicantPreview = false;
}
// getCoApplicantPhotographcertificateFileInput() {
//   if (this.fileToUpload) {
//     return this.fileToUpload.name;
//   }
//   return null;
// }


 CoApplicantSignaturecertificateFileInput(event: any) {

  const file: File = event.target.files[0];

  // if (!file) return;

    if (!file) {
    // User cleared the input — wipe the preview too
    this.coapplicantsignaturePreview = null;
    this.showcoapplicantsignaturePreview = false;
    this.app.APP_SA_Signature = "";
    this.checkAllRequiredDocuments();
    return;
  }


  const regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;

  const sizeInKB = file.size / 1024;
  const uploadedFilename = file.name;

  // ✅ Validation
  if (!uploadedFilename.match(regex)) {
    swal('Warning!', "Please upload an image file with extension .jpg", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_SA_Signature = "";
    return;
  }

  if (sizeInKB > 2048) {
    swal('Warning!', "Please upload file less than 2MB", 'warning');
    this.resetsignatureFileInput();
    this.app.APP_SA_Signature = "";
    return;
  }

  // ✅ Store file
  this.fileToUpload = file;

  // ✅ Preview Image
  const reader = new FileReader();
  reader.onload = (e: any) => {
    this.coapplicantsignaturePreview = e.target.result;
  };
  reader.readAsDataURL(file);

  // ✅ Upload to Server
  const data = new FormData();
  data.append("UploadedImage", file);

  this.userService.uploadImage(data).subscribe(
    (response: any) => {
      console.log(response);
      this.app.APP_PA_PhotoErrorMessage = "";
    },
    (error) => {
      this.resetcoapplicantFileInput();
      this.app.APP_SA_Signature = "";
      if (error.status === 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    }
  );
}

resetcosignatureFileInput() {
  if (this.imageInput) {
    this.imageInput.nativeElement.value = '';
  }
  this.coapplicantsignaturePreview = null;
  this.showcoapplicantsignaturePreview = false;
}
// getCoApplicantSignaturecertificateFileInput() {
//   if (this.fileToUpload) {
//     return this.fileToUpload.name;
//   }
//   return null;
// }
  //  CoApplicantSignaturecertificateFileInput(file: FileList) {
  
  //     // let regex = /^([a-zA-Z0-9\s_\\.\-:])+(\.jpeg|\.jpg)$/i;
  //   //  let regex = /^([a-zA-Z0-9\s_\.\-\:\(\)\\])+(\.jpeg|\.jpg|\.png|\.pdf)$/i;
  // //  let regex = /^[^\\/]+(\.jpeg|\.jpg|\.png|\.pdf|\.bmp)$/i;
  //  let regex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+\.jpg$/i;
  //     let s: any = file.item(0).size / 1024;
  //     let size: any = parseFloat(s).toFixed(2);
  //     let uploadedFilename = file.item(0).name;
  //     if (uploadedFilename.match(regex) && (size <= 2048)) {
  //       this.fileToUpload = file.item(0);
  //       var reader = new FileReader();
  //       reader.onload = (event: any) => {
  //         // this.UO_UploadimageUrl1 = event.target.result;
  //       }
  //       reader.readAsDataURL(this.fileToUpload);
  //       const data = new FormData();
  //       data.append("UploadedImage", file.item(0));
  //       let x = this.userService.uploadImage(data);
  //       x.subscribe(
  //         (response) => {
  //           console.log(response);
  //           this.app.APP_SA_SignatureErrorMessage = "";
  //         }, (error) => {
  //           let i: any = document.getElementById('APP_SA_Signature');
  //           i.value = "";
  //           if (error.status == 400) {
  //             // this.UO_UploadimageUrl1 = "assets/images/image-default.png";
  //             swal('Warning!', error.error.Message, 'warning');
  //           }
  //         });
  //     }
  //     else {
  //       let i: any = document.getElementById('APP_SA_Signature');
  //       i.value = "";
  //       if (!uploadedFilename.match(regex))
  //         swal('Warning!', "Please upload a  image file with extension .jpg", 'warning');
  //       else if (size > 2048)
  //         swal('Warning!', "Please upload file less than 2mb", 'warning');
  //     }
  //   }
  
  //   getCoApplicantSignaturecertificateFileInput() {
  //     let imagename = null;
  //     try {
  //       imagename = document.getElementById('APP_SA_Signature');
  //       return imagename.files[0].name;
  //     }
  //     catch (e) {
  //       return null;
  //     }
  //   }
    SaveApplicationstep1(ApplicationForm: NgForm) {
     debugger;
      console.log(JSON.stringify(ApplicationForm.value));
        ApplicationForm.value.APP_PropertyType = this.NotificationPropertyType;

      ApplicationForm.value.APP_SA_Signature = this.getCoApplicantSignaturecertificateFileInput();
      ApplicationForm.value.APP_SA_Photo = this.getCoApplicantPhotographcertificateFileInput();
      
      ApplicationForm.value.APP_PA_Signature = this.getSignatureoftheapplicantFileInput();
      ApplicationForm.value.APP_PA_Photo = this.getApplicantPhotographcertificateFileInput();
       ApplicationForm.value.APP_PA_MobileNo = this.r.Mobile_No;
     ApplicationForm.value.APP_PA_Email = this.r.Email;
     ApplicationForm.value.APP_PA_Age = this.APP_PA_Age;
      ApplicationForm.value.APP_SA_Age = this.APP_SA_Age;
  ApplicationForm.value.APP_VI_Name_PERM = this.r.Village_Mohalla;
   ApplicationForm.value.Post_Office_PERM = this.r.Post_Office;
 ApplicationForm.value.Police_Station_PERM = this.r.Police_Station;
  ApplicationForm.value.APP_DI_Id_FK_PERM = this.r.District_Id_Fk;
  ApplicationForm.value.APP_Pincode_PERM = this.r.Pincode;
  ApplicationForm.value.PAmount = this.r.Paid_Amount;
  ApplicationForm.value.APP_BankName = this.r.Bank_Name
  ApplicationForm.value.APP_Project_Id_FK = this.PD.PD_Id;
  ApplicationForm.value.APP_Not_Id_Fk = this.PD.NO_Id;
  ApplicationForm.value.APP_DI_Id_FK = this.r.District_Id_Fk;    
  ApplicationForm.value.APP_UserId_Fk = this.r.APP_Userid_FK;
  ApplicationForm.value.APP_Reg_No = this.r.APP_REG_NO;
  ApplicationForm.value.Gender = this.r.Gender;
  ApplicationForm.value.APP_Pincode = this.r.Pincode;  
  ApplicationForm.value.APP_Reservation_Id_FK = this.r.CA_id_fk;
  ApplicationForm.value.Aadhar_No = this.r.Aadhar_No; 
  ApplicationForm.value.APP_VI_Name_PERM = this.r.Village_Mohalla;
   ApplicationForm.value.Applicant_Name = this.r.Applicant_Name;
   ApplicationForm.value.APP_AnnualIncome = this.app.APP_CA_Id_FK;
    ApplicationForm.value.APP_CA_Id_FK = this.app.APP_CA_Id_FK; 
    
    
    
 
     
    
      ApplicationForm.value.BankChallan_No = this.r.Transaction_Id;
      //ApplicationForm.value.Date_Of_Birth =  this.r.Date_Of_Birth;
      //ApplicationForm.value.Submitted_Date =  this.r.Submitted_Date;
      ApplicationForm.value.Payment_Mode = this.r.Payment_Mode;
      ApplicationForm.value.Bank_Branch = this.r.Branch;
    
      // this.formInvalid = false;
      // document.getElementById('loader-spinner').style.display = "block";
      // ApplicationForm.value.APP_Project_Id_FK = this.PD_Id;
      Object.keys(ApplicationForm.controls).forEach(key => {
        const control = ApplicationForm.controls[key];
        if (control.invalid) {
          console.log(`Invalid Field: ${key}, Errors:`, control.errors);
        }
      });
      if (ApplicationForm.invalid) {
        this.formInvalid = true;
        swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
        return;
      }
      else {
        this.data = this.userService.step1Applicationform(ApplicationForm.value);
        this.data.subscribe(
          (response) => {
            console.log(response.ApplicationForm);
            ApplicationForm.reset();
            ApplicationForm.resetForm();
            this.formInvalid = false;
  
            if (response.Result === "Invalid Transaction Id for Application Fees") {
              swal('Warning!', response.Result, 'warning')
            }
  
            if (response.Result === "Invalid Transaction Id for Initial Deposit") {
              swal('Warning!', response.Result, 'warning')
            }
  
            if (response.Result === "Applicant already applied for this notification") {
              swal('Warning!', response.Result, 'warning')
            }

           if (response.Result === "Applicant data not saved") {
              swal('Warning!', response.Result, 'warning')
            }

            // Applicant data not saved
            else {
              swal('Success!', 'Notification and Personal Details are Saved Sucessfully, Please Continue with Step2', 'success');
              sessionStorage.setItem('step1Completed', '1');
              // localStorage.removeItem('applicationFeePaid');
              // localStorage.removeItem('idAmountPaid');
              // this.removeBeforeUnloadProtection();
  //             this.router.navigate(
  //   ['/appform-payment-summary'],
  //   { queryParams: { appNo: response.Result} }
  // );
//   this.router.navigate(
//   ['/against-notification-form2'],
//   { queryParams: { APP_Reg_No: response.Result } }
// );

this.router.navigate(
  ['/against-notification-form2'],
  { 
    queryParams: { 
      App_Reg_No: response.App_Reg_No,
      IsJoint: response.IsJoint,
    } 
  }
);
              // this.router.navigate(['/against-notification-form2']);
            }
  
            document.getElementById('loader-spinner').style.display = "none";
  
            //this.router.navigate(['home/applicant/applicantview/',this.APP_Id]);
            // window.location.href(='home/applicantview/';
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
            else {
              swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
              this.formInvalid = true;
            }
          });
      }
  
  
    }



     onCategoryChange(): void {
    // debugger;
    // Check if a category has been selected
    if (this.app.APP_CA_Id_FK) {
      // Set APP_AnnualIncome to the value of the selected category ID
      this.app.APP_AnnualIncome = this.app.APP_CA_Id_FK;

      // Disable all radio buttons
      this.disableRadioButtons();
    } else {
      // If no category is selected, reset APP_AnnualIncome and enable all radio buttons
      this.app.APP_AnnualIncome = undefined;
      this.enableAllRadioButtons();
    }
  }
disableRadioButtons() {
    const radioButtons = Array.from(
      document.querySelectorAll('input[type="radio"][name="APP_AnnualIncome"]')
    ) as HTMLInputElement[];

    radioButtons.forEach((radio) => {
      radio.disabled = true;
    });

    const selectedRadio = document.querySelector(
      `input[type="radio"][value="${this.app.APP_AnnualIncome}"]`
    ) as HTMLInputElement | null;
    if (selectedRadio) {
      selectedRadio.disabled = false;
    }
  }
    enableAllRadioButtons() {
    const radioButtons = Array.from(
      document.querySelectorAll('input[type="radio"][name="APP_AnnualIncome"]')
    ) as HTMLInputElement[];

    radioButtons.forEach((radio) => {
      radio.disabled = false;
    });
  }
// getCategoryforform(NotificationId: number) {

//   this.userService
//       .getCategoryforformstep1(NotificationId)
//       .subscribe(
//         (response: any) => {
//           this.Categories = response;
          
//         },
//         (error) => {
//           console.error(error);
//         }
//       );
// }



 getSignatureoftheapplicantFileInput() {
  debugger;
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_Signature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


    getApplicantPhotographcertificateFileInput() {
      debugger;
    let imagename = null;
    try {
      imagename = document.getElementById('APP_PA_Photo');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

   getCoApplicantSignaturecertificateFileInput() {
    debugger;
    let imagename = null;
    try {
      imagename = document.getElementById('APP_SA_Signature');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }


getCoApplicantPhotographcertificateFileInput() {
  debugger;
    let imagename = null;
    try {
      imagename = document.getElementById('APP_SA_Photo');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }




getCategoryforform(notificationId: number, selectedCategoryId?: number) {

  this.userService
    .getCategoryforformstep1(notificationId)
    .subscribe({
      next: (response: any) => {

        this.Categories = response;

        // 🔥 Auto select value after categories load
        if (selectedCategoryId !== undefined && selectedCategoryId !== null) {
          this.app.APP_CA_Id_FK = Number(selectedCategoryId);
        }

      },
      error: (error) => {
        console.error('Category Load Error:', error);
      }
    });
}



 checkAllRequiredDocuments(): void {
  const requiredExisting = [
    this.existingFiles.APP_PA_Photo,
    this.existingFiles.APP_PA_Signature,
  
  ];

  const requiredApp = [
    this.app.APP_PA_Photo,
    this.app.APP_PA_Signature,
  //   this.app.APP_Income_Certificate,
  //   this.app.APP_Affidavit_Certificate,
  //   this.app.bank_passbook,
  //   this.app.VoterCard,
  // ];
  ]

  // A field is satisfied if EITHER existingFiles OR app (newly uploaded) has a valid value
  this.isDocumentsLoaded = requiredExisting.every((existingVal, index) =>
    this.checkValid(existingVal) || this.checkValid(requiredApp[index])
  );
}











// checkValid(value: any): boolean {
//   return value &&
//          value !== 'NA.jpg' &&
//          value !== 'null' &&
//          value !== null &&
//          value !== '';
// }
// checkValid(value: any): boolean {
//   if (!value || value === null || value === '' || value === 'null') {
//     return false;
//   }

//   // Extract just the filename, stripping path and query string
//   // e.g. ".../PAPhoto/NA.jpeg?3/5/2026 12:38:10 PM" → "NA.jpeg"
//   const filename = value.split('/').pop()?.split('?')[0]?.toLowerCase() ?? '';

//   const invalidFiles = ['na.jpg', 'na.jpeg', 'na.png', 'default.jpg'];

//   return !invalidFiles.includes(filename);
// }


checkValid(value: any): boolean {
  if (!value || value === null || value === '' || value === 'null') {
    return false;
  }

  // Extract just the filename, stripping path and query string
  const parts = value.split('/');
  const lastPart = parts[parts.length - 1] || '';
  const filename = (lastPart.split('?')[0] || '').toLowerCase();

  const invalidFiles = ['na.jpg', 'na.jpeg', 'na.png', 'default.jpg'];

  return invalidFiles.indexOf(filename) === -1;
}



}




// WEBPACK FOOTER //
// ./src/app/registration/against-notification-form/against-notification-form.component.ts